import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const ConfirmDialog = ({
  open, onOpenChange, title, description, confirmLabel = "Confirm",
  onConfirm, destructive = false, testId = "confirm-dialog",
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-white" data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-emerald-950">{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testId}-confirm`}
            onClick={onConfirm}
            className={destructive ? "bg-rose-700 text-white hover:bg-rose-800" : "bg-[#0F4C3A] text-white hover:bg-emerald-900"}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
